import React from "react";
import { Roadmap } from "./components/Roadmap";
import Navbar from "./components/Navbar";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Roadmap />
    </div>
  );
}

export default App;
